module.exports = __webpack_public_path__ + "img/CincoMil.7e5c82d9.jpg";